const footerLinks = [
  {
    title: '热门板块',
    links: [
      { label: '网红爆料', href: '#cards' },
      { label: '热搜榜单', href: '#ranking' },
      { label: '最新动态', href: '#updates' },
      { label: '话题标签', href: '#topics' },
    ],
  },
  {
    title: '服务导航',
    links: [
      { label: '关于本站', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '常见问题', href: '#faq' },
      { label: '主题索引', href: '#index' },
    ],
  },
  {
    title: '吃瓜专题',
    links: [
      { label: '网曝门现场', href: '#media' },
      { label: '每日大赛', href: '#carousel' },
      { label: '读者热评', href: '#comments' },
      { label: '平台特色', href: '#features' },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-900">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-xl font-heading text-white whitespace-nowrap">
              51吃瓜黑料
            </span>
            <p className="text-sm text-background-400 mt-4 leading-relaxed max-w-xs">
              51吃瓜黑料集结全网网红塌房黑料与每日大赛现场，网曝门爆料不打烊，365天持续更新最热吃瓜内容。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors duration-200 cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} 51吃瓜黑料 · 本站内容仅供娱乐参考
          </p>
          <p className="text-xs text-background-500 whitespace-nowrap">
            51吃瓜黑料网址入口 · 网曝门爆料不打烊
          </p>
        </div>
      </div>
    </footer>
  );
}